import type {ChangeEvent, ReactElement} from 'react';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import type {CheckboxProps} from './checkbox.types';
import {CheckboxSize} from './checkbox.types';
import styles from './checkbox.module.scss';

export function Checkbox({isChecked, onChange, size = CheckboxSize.MD, isDisabled = false, ariaLabel, className = '', 'data-testid': dataTestId}: CheckboxProps): ReactElement {
  const isSmall = size === CheckboxSize.SM;

  const reportChange = (event: ChangeEvent<HTMLInputElement>): void => {
    onChange(event.target.checked);
  };

  return (
    <span className={`${styles.checkbox} ${isSmall ? styles.small : styles.medium} ${className}`}>
      <input type="checkbox" className={styles.input} checked={isChecked} disabled={isDisabled} aria-label={ariaLabel} data-testid={dataTestId} onChange={reportChange} />
      <Icon icon="icon-check" size={isSmall ? IconSize.SIZE_ICON_12 : IconSize.SIZE_ICON_16} className={styles.checkGlyph} ariaHidden />
    </span>
  );
}
